<template>
  <div class="privacy-page">
    <div class="content">
      <h1>隐私政策</h1>
      <div class="item">
        <h2>微博营销平台个人信息保护政策</h2>
        <p>
          微博营销平台运营方（以下简称“我们”）非常注重保护用户（以下简称“您”）的个人信息，我们深知个人信息对您的重要性。为切实保护您的权益，优化您的体验，我们根据现行法律法规及政策要求，制定本个人信息保护政策（以下简称“本政策”）。本政策将详细说明我们在获取、管理及保护您个人信息方面的政策及措施。本政策适用于我们向您提供的所有服务，无论您是通过计算机设备、移动终端或其他设备获得。
        </p>
        <p>
          <strong
            >本政策是您使用我们提供的微博营销平台服务及其他相关各项产品/服务（以下简称“微博营销平台服务”）的基础性文件，我们希望您在使用微博营销平台服务前仔细阅读并明确您已经充分理解、接受本政策的内容（重点内容我们已将字体加粗或增加下划线，请您特别关注），希望您可以根据自己的理解做出合适的选择。我们努力通过通俗的语言表述本政策中涉及的相关术语，以便您更好地理解。一旦您使用或继续使用我们的产品/服务，即意味着您同意本政策（含更新版本）内容，并且同意我们按照本政策收集、使用、保存和共享您的相关信息。</strong
          >
        </p>
      </div>
      <div class="item">
        <h2>第一部分 定义</h2>
        <p>
          1．微博营销平台：指网址为https://marketing.hd.weibo.com/的网络平台、客户端及其自媒体平台。
        </p>
        <p>
          2．微博营销平台运营方：指微博营销平台的网络及技术服务提供者。&nbsp;<strong
            >微博营销平台运营方可能根据平台业务调整而发生变更，或将本政策项下权利义务委托给其关联公司进行运营、管理及履行，微博营销平台运营方将竭力避免前述变更或委托给您的使用带来不便，并通过适当方式进行通知。</strong
          >
        </p>
        <p>
          3．微博营销平台服务：指微博营销平台运营方通过微博营销平台向您提供的产品/服务。
        </p>
        <p>
          <strong
            >4．个人信息：指以电子或其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反应特定自然人活动情况的各种信息。</strong
          >
        </p>
        <p>
          5．个人敏感信息：指一旦泄露、非法提供或滥用可能危害人身和财产安全，极易导致个人名誉、身心健康受到损害或歧视性待遇等的个人信息。如身份证件号码、个人生物识别信息、通信记录和内容、账号密码、银行账号、财产信息、交易信息、征信信息、14岁以下（含）儿童信息等的个人信息。
        </p>
        <p>
          6．关联公司：指一方控制另一方或为另一方所控制或双方共同受控制于同一实体的任何企业。控制是指直接或间接拥有该企业百分之五十（50％）以上的股权、投票权或管理权。
        </p>
      </div>
      <div class="item">
        <h2>第二部分 个人信息保护政策</h2>
        <p><strong>本政策将帮助您了解以下内容：</strong></p>
        <p>1．我们如何收集和使用您的个人信息；</p>
        <p>2．我们如何使用 Cookie 和同类技术；</p>
        <p>3．我们如何共享、转让、公开披露您的个人信息；</p>
        <p>4．我们如何保存和保护您的个人信息；</p>
        <p>5．您如何管理您的个人信息；</p>
        <p>6．未成年人的个人信息保护；</p>
        <p>7．通知和修订；</p>
        <p>8．争议解决；</p>
        <p>9．如何联系我们。</p>
        <p>
          本政策涉及的个人信息包括：基本信息（包括个人姓名、生日、性别、住址、个人电话号码、电子邮箱）；个人身份信息（包括身份证、军官证、护照、驾驶证、相关身份证明等）；财产信息（包括交易记录以及金币等虚拟财产信息）；个人位置信息；网络身份标识信息（包括系统账号、IP地址、邮箱地址及与前述有关的密码、密保）；通讯录；个人上网记录（包括搜索记录、软件使用记录、点击记录）；个人常用设备信息（包括硬件型号、设备MAC地址、操作系统类型）；软件列表唯一设备识别码（如IMEI/android
          ID/IDFA/OPENUDID/GUID、SIM卡IMSI信息等在内的描述个人常用设备基本情况的信息）。
        </p>
      </div>
      <div class="item">
        <h2>一、我们如何收集和使用您的个人信息</h2>
        <p>
          我们会遵循正当、合法、必要的原则，出于本政策所述的目的、方式，仅在出现下列情况时收集和使用您在使用微博营销平台服务过程中主动提供或产生的个人信息。如果您不同意提供个人信息，您将无法使用全部或部分的微博营销平台服务，或无法获得更个性化的功能，或无法参加某些活动，或无法收到我们的通知等。
        </p>
        <p>1．您向我们提供的个人信息</p>
        <p>
          您已知悉且同意，在您注册微博营销平台账号或使用微博营销平台服务时，我们将收集您提供的账户昵称、手机号码等相关个人信息，上述个人信息是您获得我们提供之服务的基础。若您未登录微博营销平台而仅在平台使用浏览、搜索功能，我们不会收集您的上述个人信息。若您使用第三方账号（微博、微信、QQ、中国移动等）关联登录微博营销平台，您将授权我们向关联第三方请求您的个人信息，对于我们要求但第三方无法提供的个人信息，我们仍可以要求您提供。如果您拒绝提供这些信息，将影响您使用微博营销平台服务。
        </p>
        <p>2．我们在您使用服务过程中可能收集的个人信息</p>
        <p>
          基于优化用户体验之目的，我们会获取与提升微博营销平台服务有关的其他信息，例如当您访问微博营销平台时，我们可能会收集哪些服务的受欢迎程度、浏览器软件信息等，以便优化我们的服务。
        </p>
        <p>
          在您使用我们提供的搜索服务时，我们会收集您的查询关键字信息、设备信息等，为了提供高效的搜索服务。&nbsp;<strong
            >在此，您需要注意的是，您的关键词信息无法单独识别您的个人身份，其不属于您的个人信息，因此我们有权以其他的目的对其进行使用；只有当您的搜索关键词信息与您的其他信息互有联系并可以识别您的个人身份时，则在结合使用期间，我们会将您的搜索关键词信息作为您的个人信息，与您的搜索历史记录一同按照本政策对其进行处理与保护。</strong
          >
        </p>
        <p>
          在您使用我们提供的身份认证服务时，我们会收集您的姓名、身份证号、有关身份证明等信息，我们对您的这些个人信息会加以最大程度的保护，如果您不提供这些信息，我们将无法提供相关服务。
        </p>
        <p>
          当您参加我们的有关营销活动时，我们可能会收集您的姓名、年龄、通讯地址、联系方式、身份信息、银行或支付交易账号等信息。这些信息是您收到转账或礼品的基础，如果您拒绝提供这些信息，我们将无法向您转账或发放礼品。
        </p>
        <p>
          基于对您信息的有效保护并且在您同意的基础上，我们会对收集到的您的信息进行去标签化处理，以保护您的信息安全。&nbsp;<strong
            >在此希望您了解并接受在不透露您个人信息的前提下，我们有权对您的信息进行分析并予以商业化的利用。</strong
          >
        </p>
        <p>3．我们可能使用个人信息的情形</p>
        <p>
          为了向您提供更好的微博营销平台服务，我们会在下述情形使用您的个人信息：
        </p>
        <p>（1） 根据相关法律法规的要求；</p>
        <p>（2） 根据您的授权；</p>
        <p>（3） 根据微博营销平台相关服务条款、应用许可使用协议的约定。</p>
        <p>
          此外，您已知悉并同意：在现行法律法规允许的范围内，我们可能会将您非敏感的个人信息用于市场营销，使用方式包括但不限于：我们会使用您所提供信息在微博营销平台平台中向您展示或提供广告和促销资料，向您通告或推荐微博营销平台的服务或产品信息，以及其他此类根据您使用微博营销平台服务或产品的情况所认为您可能会感兴趣的信息。其中也包括您在采取授权等某动作时选择分享的信息，例如当您下载某项案例、购买某项课程等。
        </p>
        <p>
          4．请您知悉，以下情形中，我们收集、使用个人信息无需征得您的授权同意：
        </p>
        <p>（1） 与国家安全、国防安全有关的；</p>
        <p>（2） 与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>（3） 与犯罪侦查、起诉、审判和判决执行等有关的；</p>
        <p>
          （4）
          出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        </p>
        <p>（5） 您自行向社会公众公开的个人信息；</p>
        <p>
          （6）
          从合法公开披露的信息中收集的您的个人信息，如合法的新闻报道、政府信息公开等渠道；
        </p>
        <p>（7） 根据您的要求签订合同所必需的；</p>
        <p>
          （8）
          用于维护所提供的产品/服务的安全稳定运行所必需的，例如发现、处置产品/服务的故障；
        </p>
        <p>（9） 为合法的新闻报道所必需的；</p>
        <p>
          （10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
        </p>
        <p>（11）法律法规规定的其他情形。</p>
        <p>
          <strong
            >如在上述场景之外获得您的个人信息，将重新征得您的明示同意，并在获得您明示同意前向您充分说明应用场景与获取您相关信息的内容与范围。</strong
          >
        </p>
        <p>
          特别注意：无法与任何特定个人直接建立联系的数据，不属于个人信息。如果我们将无法与任何特定个人建立联系的数据与其他信息结合用于识别个人身份，或者将其与个人信息结合使用，则在结合使用期间，此类信息将被视为个人信息。
        </p>
      </div>
      <div class="item">
        <h2>二、我们如何使用 Cookie和同类技术</h2>
        <p>1．Cookie的使用</p>
        <p>
          为确保网站正常高效运转、为您获得更轻松的访问体验、向您推荐您可能感兴趣的内容，我们会在您的设备终端/系统上存储名为Cookie的小数据文件。Cookie会帮助您在后续访问我们网站时调用您的信息，简化您填写个人信息（例如一键登录等）的流程；为您提供偏好设置；保护您的数据安全等。我们承诺，仅将Cookie用于提升服务/产品质量及优化用户体验之目的，不会将Cookie用于本政策所述目的之外的任何用途。您可以根据自己的偏好管理或删除Cookie，您也可以清除计算机或移动设备上保存的所有Cookie，您有权接受或拒绝Cookie。另外，您也可以清除软件内保存的所有Cookie。但您完成前述关闭、清除等操作后，可能因此无法完全体验我们某些便捷性和安全性的服务功能。
        </p>
        <p>2．网络Beacon和同类技术的使用</p>
        <p>
          除Cookie外，我们网页上常会包含一些电子图象（称为“单像素”GIF文件或“网络Beacon”）等其他同类技术，它们可以帮助网站计算浏览网页的用户或访问某些Cookie。
        </p>
        <p>我们使用网络Beacon的方式有：</p>
        <p>
          （1）
          我们通过在我们网站上使用网络Beacon，计算用户访问数量，并通过访问Cookie辨认注册用户。
        </p>
        <p>（2） 我们通过得到的Cookie信息，可以在我们网站提供个性化服务。</p>
      </div>
      <div class="item">
        <h2>三、我们如何共享、转让、公开披露您的个人信息</h2>
        <p>
          1．我们会以高度的勤勉义务对待您的个人信息，未经您本人允许，不会与我们关联公司以外的任何公司、组织和个人公开（包括共享、转让、公开披露等方式）您的个人信息，但下列情形除外：
        </p>
        <p>（1） 已经取得您或您监护人的授权或同意；</p>
        <p>
          （2）
          根据法律法规的规定、诉讼争议解决需要，或行政、司法等有权机关依法提出的要求；
        </p>
        <p>（3） 我们为维护自身合法权益而向您提起诉讼或仲裁时；</p>
        <p>
          （4）
          根据您与我们签署的相关协议（包括在线签署的电子协议及平台规则）或法律文件的约定；
        </p>
        <p>
          （5）
          在法律允许的范围内，为保障微博营销平台、微博营销平台用户以及社会公共利益免受损害时；
        </p>
        <p>
          （6）
          由于我们的某些服务将由业务合作伙伴提供，为保障向您提供的服务顺利完成，我们可能会将您的经过去标识化或匿名处理后的个人信息共享给前述合作伙伴，包括身份认证服务、地理位置服务、支付服务、技术服务、配送服务等，其中可能包括您的肖像/姓名/身份信息、位置信息、支付信息、订单信息、地址信息、个人形象等。我们的业务合作伙伴无权将共享的个人信息用于其他任何用途；
        </p>
        <p>
          2．随着我们业务的发展，我们及我们的关联公司有可能进行合并、收购、资产转让或类似的交易，去标识化或匿名处理后的个人信息有可能作为此类交易的一部分而被转移，我们将要求受让您个人信息的公司、组织继续接受本政策的约束。
        </p>
        <p>3. 共享、转让、公开披露个人信息时事先征得授权同意的例外：</p>
        <p>（1） 与国家安全、国防安全有关的；</p>
        <p>（2） 与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>（3） 与犯罪侦查、起诉、审判和判决执行等有关的；</p>
        <p>
          （4）
          出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        </p>
        <p>（5） 您自行向社会公众公开的个人信息；</p>
        <p>
          （6）
          从合法公开披露的信息中收集的您的个人信息，如合法的新闻报道、政府信息公开等渠道。
        </p>
      </div>
      <div class="item">
        <h2>四、我们如何保存和保护您的个人信息</h2>
        <p>
          我们将尽一切合理努力保护所获得的用户个人信息，并由专门的数据安全部门对个人信息进行保护。为防止用户个人信息在意外的、未经授权的情况下被非法访问、复制、修改、传送、遗失、破坏、处理或使用，我们已经并将继续采取以下措施保护您的个人信息：
        </p>
        <p><strong>1．微博营销平台运营方采取的安全措施</strong></p>
        <p>
          （1）
          我们的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保用户数据在传输过程中的安全；
        </p>
        <p>
          （2）
          通过采取加密技术对用户个人信息进行加密保存，并通过隔离技术进行隔离；
        </p>
        <p>
          （3）
          在个人信息使用时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、加密脱敏等多种数据脱敏技术增强个人信息在使用中安全性；
        </p>
        <p>
          （4）
          设立严格的数据使用和访问制度，采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用；
        </p>
        <p>
          （5） 采取专门的数据和技术安全审计，设立日志审计和行为审计多项措施；
        </p>
        <p>
          （6）
          通过建立数据分类分级制度、数据安全管理规范、数据安全开发规范来管理规范个人信息的存储和使用；
        </p>
        <p>
          （7）
          建立数据安全专项部门，负责安全应急响应组织来推进和保障个人信息安全。
        </p>
        <p><strong>2．个人信息安全事件的通知</strong></p>
        <p>
          （1）
          如发生个人信息引发的安全事件，我们将第一时间向相应主管机关报备，并即时进行问题排查，开展应急措施；
        </p>
        <p>
          （2）
          通过与全量用户发送通知提醒，还可能通过电话、短信等各种方式触达用户知晓，在微博营销平台平台运营宣传，制止数据泄露。
        </p>
        <p>
          尽管已经采取了上述合理有效措施，并已经遵守了相关法律规定要求的标准，但我们仍然无法保证您的个人信息通过不安全途径进行交流时的安全性。因此，您应采取积极措施保证个人信息的安全，如：不将账号、验证码等个人信息透露给他人等。
        </p>
        <p>
          <strong
            >您知悉：我们提供的个人信息保护措施仅适用于微博营销平台平台，一旦您离开微博营销平台平台，浏览或使用其他网站、服务及内容资源，我们即没有能力及义务保护您在微博营销平台以外的网站提交的任何个人信息，无论您登录或浏览上述网站是否基于微博营销平台的链接或引导。</strong
          >
        </p>
        <p>
          网络环境中始终存在各种信息泄漏的风险，当出现意外事件、不可抗力等情形导致您的信息出现泄漏时，我们将极力控制局面，及时告知您事件起因、我们采取的安全措施、您可以主动采取的安全措施等相关情况。
        </p>
        <p><strong>3．个人信息的存储</strong></p>
        <p>
          我们会采取合适的安全措施和技术手段存储及保护您的个人信息，以防止<strong>丢失、被误用、受到未授权访问或泄漏、被篡改或毁坏。您的个人信息存放在有密码控制的位于中国境内的服务器中</strong>，访问均是受到限制的。当您需要跨境信息传输服务时，我们会默认您继续使用中国境内的服务器。我们如涉及向境外传输个人信息，将会向您明确告知并征得您的同意。除非法律法规另有规定，我们将在您使用微博营销平台服务期间持续保存您的个人信息。
        </p>
      </div>
      <div class="item">
        <h2>五、您如何管理您的个人信息</h2>
        <p>
          当您完成微博营销平台的账号注册并进行合理和必要的身份验证后，您可以查阅、修改、删除您提交给我们的个人信息。一般情况下，您可随时浏览、修改、删除自己提交的信息，但出于安全性和身份识别（如号码申诉服务）的考虑，您可能无法修改注册时提供的某些初始注册信息及验证信息。
        </p>
        <p>
          我们始终将对您个人信息的保护放在首位，同时，我们重视您对个人信息的关注。
        </p>
        <p>
          您有权自主更新或更正您的个人信息，或授权微博营销平台客服进行信息更新、更正。在您进行信息更新更正之前，我们会首先验证您的身份，其次才能进行信息的更正与更新。
        </p>
        <p>
          如果您对本政策或其中有关您个人信息的收集、使用、存储、保护等存在意见或建议时，您可以通过第九条提供的微博营销平台客户服务渠道反馈意见或投诉，我们会在收到您意见及建议的第一时间将反馈信息回复给您。
        </p>
        <p>
          您可以通过关闭微博营销平台部分功能的方式阻止我们获得您的个人信息，关闭部分功能之后，我们将无法向您提供相应的服务。
        </p>
        <p>
          <strong
            >如果我们终止服务或运营，我们会至少提前三十日向您通知，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。</strong
          >
        </p>
      </div>
      <div class="item">
        <h2>六、未成年人的个人信息保护</h2>
        <p>
          我们非常重视对未成年人个人信息的保护。若您是14周岁以下的未成年人，在使用我们提供的服务前，应确保事先取得监护人的同意，如果您是已满14不满18岁的未成年人，在使用我们提供的服务前，应确保事先取得本人或监护人的同意。如您在微博营销平台上申请注册账号，我们将默认为您已得到前述同意。我们将根据国家相关法律法规及本政策的规定保护未成年人的个人信息。
        </p>
      </div>
      <div class="item">
        <h2>七、通知和修订</h2>
        <p>
          1．为给您提供更好的服务以及随着我们业务的发展，本政策也会随之更新。但未经您明确同意，我们不会削减您依据当前生效的本政策所应享有的权利。我们会通过在网站、移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问我们以便及时了解最新的个人信息保护政策。在前述情况下，若您继续使用我们的服务，即表示同意接受修订后的本政策并受之约束。
        </p>
        <p>
          <strong
            >2．对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信、私信或在浏览页面做特别提示等方式，说明本政策的具体变更内容）。本政策所指的重大变更包括但不限于：</strong
          >
        </p>
        <p>
          （1）
          我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；
        </p>
        <p>
          （2）
          我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；
        </p>
        <p>（3） 个人信息共享、转让或公开披露的主要对象发生变化；</p>
        <p>（4） 您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
        <p>
          （5）
          我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；
        </p>
        <p>（6） 个人信息安全影响评估报告表明存在高风险时。</p>
      </div>
      <div class="item">
        <h2>八、争议解决</h2>
        <p>
          本政策的订立、效力、解释、适用及争议解决等一切事宜，均适用中华人民共和国法律。当您因为本政策的实施与我们产生任何纠纷时，双方应首先友好协商解决；若不能协商解决，双方有权依照《微博营销平台用户服务协议》向有管辖权的法院提起诉讼。
        </p>
      </div>
      <div class="item">
        <h2>九、如何联系我们</h2>
        <p>
          如果您对于本政策或我们的个人信息处理行为存在任何疑问，您可以通过拨打微博营销平台客服电话4000-970-970与我们联系并作充分描述，我们会及时解决您的问题。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapState: userMapState } = createNamespacedHelpers('user')
export default {
  computed: {
    ...userMapState(['userInfo'])
  }
}
</script>
<style lang="scss" scoped>
.privacy-page {
  padding: 150px 0 88px;
  .content {
    width: 984px;
    margin: 0 auto;
  }
  .item {
    margin-bottom: 24px;
  }
  h1 {
    text-align: center;
    font-size: 20px;
    font-weight: bold;
    line-height: normal;
    margin-bottom: 32px;
  }
  h2,
  .title {
    margin-bottom: 16px;
    font-weight: bold;
    font-size: 16px;
  }
  p {
    margin-bottom: 12px;
    text-align: justify;
    font-size: 14px;
  }
  strong {
    font-weight: bold;
  }
}
</style>
